/**
 * provider.tsx - Chakra UI Theme Provider
 *
 * Root provider for Chakra UI and color mode.
 */

"use client"

import { ChakraProvider, defaultSystem } from "@chakra-ui/react"
import {
  ColorModeProvider,
  type ColorModeProviderProps,
} from "./color-mode"

export function Provider(props: ColorModeProviderProps) {
  return (
    <ChakraProvider value={defaultSystem}>
      <ColorModeProvider defaultTheme="light" forcedTheme="light" {...props} />
    </ChakraProvider>
  )
}
